const baseURL = {
  requestUrl: '', //请求地址
  apiPrefix: '/',//API前缀
}

baseURL.requestUrl = process.env.VUE_APP_INTERFACE_URL

export default baseURL